import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { RouterProvider } from 'react-router-dom';
import { AppProviders } from './app/providers';
import { router } from './routes';

async function enableMocks(): Promise<void> {
  if (!import.meta.env.DEV) return;
  if (import.meta.env.VITE_USE_MOCKS !== 'true') return;
  try {
    const { worker } = await import('./mocks/browser');
    await worker.start({
      onUnhandledRequest: 'bypass',
      serviceWorker: { url: '/mockServiceWorker.js' },
    });
    console.warn('[mocks] MSW ativo — VITE_USE_MOCKS=true.');
  } catch (err) {
    console.error('[mocks] Falha ao iniciar MSW — seguindo sem mocks.', err);
  }
}

function mount(): void {
  const rootEl = document.getElementById('root');
  if (!rootEl) {
    throw new Error('Root element #root not found in index.html.');
  }
  createRoot(rootEl).render(
    <StrictMode>
      <AppProviders>
        <RouterProvider router={router} />
      </AppProviders>
    </StrictMode>,
  );
}

void enableMocks().finally(mount);
